var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portlet calendar light portlet-fit bordered" },
    [
      _c("div", { staticClass: "portlet-title" }, [
        _c("div", { staticClass: "caption" }, [
          _c("i", { class: _vm.iconClass + " " + _vm.titleColor }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "caption-subject sbold uppercase",
              class: _vm.titleColor,
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "portlet-body", staticStyle: { "min-height": "300px" } },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", {
            staticClass: "has-toolbar fc fc-ltr fc-unthemed",
            staticStyle: { margin: "10px 10px 10px 10px" },
            attrs: { id: "calendar" },
          }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }